import { FileElement } from 'app/Components/Partials/FileElement/FileElement';
import { mapSizeToString } from 'app/Components/Partials/FileElement/Utils/utils';
import { useTranslations } from 'app/Infrastructure/Translations/useTranslations';
import classNames from 'classnames';
import * as React from 'react';
import { useTheme } from '~/Features/Layouts/Theme/Context/ThemeContextProvider';
import { Link } from '~/Partials/Link/Link';
import { LinkType } from '~/Partials/Link/LinkType.csharp';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import { useClickProxyAllowingTextSelection } from '~/Utils/Hooks/useClickProxyAllowingTextSelection';
import styles from './ContractDocumentBox.module.css';

export interface ContractDocumentBoxProps {
    name: string;
    sizeInBytes: number;
    downloadUrl: string;
}

export const ContractDocumentBox: React.FC<ContractDocumentBoxProps> = props => {
    const { name, sizeInBytes, downloadUrl } = props;

    const { withRoundedCorners, withBoxShadow } = useTheme();
    const { clickableRef, onProxyMouseUp, onProxyMouseDown } = useClickProxyAllowingTextSelection<HTMLAnchorElement>();
    const { t } = useTranslations('CampusApplications.MyProfile.Contracts');

    return (
        <div
            role="none"
            onMouseDown={onProxyMouseDown}
            onMouseUp={onProxyMouseUp}
            tabIndex={-1}
            title={t('Download')}
            className={classNames(
                styles.ContractDocumentBox,
                withRoundedCorners && styles['Variant--rounded'],
                withBoxShadow && styles['Variant--shadowed']
            )}
        >
            <FileElement
                name={name}
                description={mapSizeToString(sizeInBytes)}
                actions={{
                    download: (
                        <Link
                            ref={clickableRef}
                            className={styles.Download}
                            type={LinkType.Clear}
                            href={downloadUrl}
                            download={name}
                        >
                            <span className="visuallyHidden">{t('Download')}</span>
                            <SvgIcon iconName="download" className={styles.DownloadIcon} />
                        </Link>
                    ),
                }}
            />
        </div>
    );
};
